import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    public setItem(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    public getItem(key: string): string | undefined {
        const item = localStorage.getItem(key);
        // eslint-disable-next-line no-null/no-null
        return item === null ? undefined : item;
    }

    public removeItem(key: string): void {
        localStorage.removeItem(key);
    }
}
